import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
import {
  LayoutDashboard,
  Layers,
  ShoppingBag,
  Users,
  Boxes,
  Star,
  Tag,
  MessageSquare,
  Settings,
  LogOut,
  RotateCcw
} from 'lucide-react';

const Sidebar = ({ onCloseMobile }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    if (onCloseMobile) onCloseMobile();
    navigate('/admin/login');
  };

  const handleNavClick = () => {
    if (onCloseMobile) onCloseMobile();
  };

  const navItems = [
    { label: 'Dashboard', path: '/admin/dashboard', icon: LayoutDashboard },
    { label: 'Panels & Catalog', path: '/admin/panels', icon: Layers },
    { label: 'Orders', path: '/admin/orders', icon: ShoppingBag },
    { label: 'Cancelled & Refunds', path: '/admin/refunds', icon: RotateCcw },
    { label: 'Customers', path: '/admin/customers', icon: Users },
    { label: 'Inventory', path: '/admin/inventory', icon: Boxes },
    { label: 'Messages', path: '/admin/messages', icon: MessageSquare },
    { label: 'Reviews', path: '/admin/reviews', icon: Star },
    { label: 'Promotions', path: '/admin/promotions', icon: Tag },
    { label: 'Settings', path: '/admin/settings', icon: Settings },
  ];

  return (
    <aside className="admin-sidebar">
      <div>
        {/* Brand Header */}
        <div className="sidebar-brand">
          <div className="sidebar-dots-logo">
            {[...Array(9)].map((_, i) => (
              <div key={i} className="sidebar-dot"></div>
            ))}
          </div>
          <div className="sidebar-brand-text">
            <span className="sidebar-title">INFRAEDGE</span>
            <span className="sidebar-subtitle">RED LIGHT THERAPY</span>
          </div>
        </div>

        {/* E-Commerce Navigation Menu */}
        <nav className="sidebar-nav-menu">
          {navItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={handleNavClick}
                className={({ isActive }) =>
                  `sidebar-nav-link ${isActive ? 'active' : ''}`
                }
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <IconComponent size={18} />
                  <span>{item.label}</span>
                </div>
                {item.badge && (
                  <span className="badge-count-pill">{item.badge}</span>
                )}
              </NavLink>
            );
          })}
        </nav>
      </div>

      {/* Sidebar Footer (Log Out at bottom) */}
      <div style={{ paddingTop: '20px', borderTop: '1px solid var(--border-subtle)' }}>
        <button onClick={handleLogout} className="sidebar-logout-btn">
          <LogOut size={18} />
          <span>Log Out</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
